import type { EditControlConfig } from '../declare'
import { useState, useEffect, useContext } from 'react'
import { autorun, toJS } from 'mobx'
import { Form } from 'antd'
import * as Row from './row'
import { ListTableContext } from 'src/components'
import { controlFieldVerify } from 'src/components/root/helper'
import { $consts } from 'src/plugins'
import { get } from 'lodash'

/**
 * 列表表单行编辑控件
 * @param props 
 * @returns 
 */
const RowControl = (props: { config: EditControlConfig }) => {
  const table = useContext(ListTableContext)

  // 控件值
  const [value, setValue] = useState()
  useEffect(() => autorun(() => {
    const { __RECORD__: record, FIELD_NAME } = props.config
    const { dataSource } = table.tableData
    const find = dataSource.find((item: any) => item.ID === record.ID)
    setValue(get(find, FIELD_NAME))
  }), [props.config])

  // 控件 change 事件
  const handleChange = (value: any, extra: any) => {
    const { __RECORD__: record, FIELD_NAME } = props.config
    const copyDataSource = toJS(table.tableData.dataSource)
    const copyRecord = copyDataSource.find((item: any) => item.ID === record.ID)
    // 往 __RECORD__ 里面添加 __VERIFY__ 校验结果
    Object.assign(copyRecord, {
      [FIELD_NAME]: value,
      ...extra,
      __VERIFY__: {
        ...copyRecord.__VERIFY__,
        [FIELD_NAME]: controlFieldVerify(props.config, value)
      }
    })
    table.setTableData({ dataSource: copyDataSource })
  }

  // 根据 CONTROL_TYPE 获取对应控件
  const getControl = () => {
    const { CONTROL_TYPE } = props.config
    switch (CONTROL_TYPE) {
      // 文本输入框
      case $consts['TABLE/CONTROL_TYPE_TEXTINPUT']:
      case $consts['TABLE/CONTROL_TYPE_TEXTAREA']:
        return (
          <Row.TextInput
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 时间控件类型
      case $consts['TABLE/CONTROL_TYPE_DATE_DAY_SECOND']:
      case $consts['TABLE/CONTROL_TYPE_DATE_RANGE_DAY_SECOND']:
      case $consts['TABLE/CONTROL_TYPE_DATE_RANGE_DAY_MINUTE']:
      case $consts['TABLE/CONTROL_TYPE_DATE_DAY']:
      case $consts['TABLE/CONTROL_TYPE_DATE_RANGE_DAY']:
      case $consts['TABLE/CONTROL_TYPE_DATE_MONTH']:
      case $consts['TABLE/CONTROL_TYPE_DATE_RANGE_MONTH']:
      case $consts['TABLE/CONTROL_TYPE_DATE_YEAR']:
      case $consts['TABLE/CONTROL_TYPE_DATE_RANGE_YEAR']:
        return (
          <Row.DateControl
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 枚举下拉单选框
      case $consts['TABLE/CONTROL_TYPE_ENUM_SELECT']:
        return (
          <Row.EnumSelect
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 复选框控件
      case $consts['TABLE/CONTROL_TYPE_CHECKBOX']:
        return (
          <Row.CheckboxControl
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 分页下拉
      case $consts['TABLE/CONTROL_TYPE_PAGINATION_SELECT']:
        return (
          <Row.PaginationSelect
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 数字输入框：小数精度
      case $consts['TABLE/CONTROL_TYPE_NUMBERINPUT']:
      case $consts['TABLE/CONTROL_TYPE_NUMBERINPUT_TWODOT']:
      case $consts['TABLE/CONTROL_TYPE_NUMBERINPUT_THREEDOT']:
        return (
          <Row.NumberInput
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      default:
        return <div />
    }
  }

  const { __RECORD__: record, FIELD_NAME } = props.config
  const { __VERIFY__: verify } = record
  const status = verify?.[FIELD_NAME]?.invalid ? 'error' : undefined

  return (
    <Form layout='horizontal'>
      <Form.Item validateStatus={status} className='mg-b0'>
        {getControl()}
      </Form.Item>
    </Form>
  )
}

export default RowControl